import styled from "@emotion/styled";

import { copyTextToClipboard } from "../../utils/copyToClipboard";
import { msToTime } from "../../utils/date";

export const getColumns = ({ role, handleGenCode = () => {} }) => {
  return [
    {
      title: role === "student" ? "ชื่อ (ชื่อเล่น)" : "ชื่อ",
      dataIndex: "name",
      key: "name",
      width: "80px",
      align: "center",
    },
    {
      title: "Username",
      key: "username",
      dataIndex: "username",
      width: "80px",
      align: "center",
    },
    {
      title: "โค้ดที่ใช้งาน",
      key: "resetPasswordCode",
      width: "80px",
      align: "center",
      render: (_, record) => (
        <CustomResetPasswordColumn>
          <ResetPasswordCode>
            {record.resetPasswordCode || "-"}
          </ResetPasswordCode>
          <CountDown>
            {record.resetPasswordCode &&
              msToTime(new Date(record.expireDate) - new Date())}
          </CountDown>
        </CustomResetPasswordColumn>
      ),
    },
    {
      title: "",
      key: "action",
      align: "center",
      width: "80px",
      render: (_, record) =>
        record.resetPasswordCode ? (
          <CopyCodeBtn
            onClick={() => copyTextToClipboard(record.resetPasswordCode)}
          >
            คัดลอก
          </CopyCodeBtn>
        ) : (
          <GenCodeBtn onClick={() => handleGenCode(record.id)}>
            สร้างโค้ด
          </GenCodeBtn>
        ),
    },
  ];
};

const CustomBtn = styled.div`
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  padding: 14px 12px;
  margin: auto;
  width: 110px;
  height: 42px;
  font-weight: 700;
  font-size: 19px;
  line-height: 23px;
  letter-spacing: -0.02em;
  color: #ffffff;
  &:hover {
    cursor: pointer;
  }
`;
const GenCodeBtn = styled(CustomBtn)`
  border: 1px solid #16af7b;
  background: #16af7b;
  color: #fff;
`;
const CopyCodeBtn = styled(CustomBtn)`
  background: #b5f6df;
  border: 1px solid #16af7b;
  color: #16af7b;
`;
const CustomResetPasswordColumn = styled.div``;
const ResetPasswordCode = styled.div``;
const CountDown = styled.div`
  font-weight: 400;
  font-size: 10px;
  line-height: 14px;
`;
